module.exports = __webpack_public_path__ + "img/couples-001.9852da86.jpg";